'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_DB_USER_ID);
}

exports.default = getUserId;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/cookie/getUserId.js
// module id = 246
// module chunks = 1